import { useState } from "react";
import { MoveHorizontal } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { asset, money } from "@/lib/api";
import { BrandButton } from "@/components/LeadForms";

const bg = (o) => (o?.image_url ? `url(${asset(o.image_url)}) center/cover` : o?.swatch || "#e2e8f0");

export function FinishCompare({ cat, chosenId, onPick, onClose }) {
  const std = cat?.options.find((o) => !o.is_upgrade) || cat?.options[0];
  const ups = (cat?.options || []).filter((o) => o.is_upgrade);
  const [upId, setUpId] = useState(null);
  const [pos, setPos] = useState(50);
  const up = ups.find((o) => o.id === (upId || chosenId)) || ups[0];
  if (!cat) return null;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-2xl rounded-2xl" data-testid="finish-compare-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Compare {cat.name.toLowerCase()}</DialogTitle>
          <DialogDescription>Drag the slider to see the standard finish next to the upgrade.</DialogDescription>
        </DialogHeader>
        <div className="relative aspect-[4/3] rounded-2xl overflow-hidden border select-none" data-testid="finish-compare-stage">
          <div className="absolute inset-0" style={{ background: bg(up) }} />
          <div className="absolute inset-0" style={{ background: bg(std), clipPath: `inset(0 ${100 - pos}% 0 0)` }} />
          <div className="absolute inset-y-0 w-0.5 bg-white shadow-[0_0_8px_rgba(0,0,0,.4)] pointer-events-none" style={{ left: `${pos}%` }}>
            <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-white text-slate-900 grid place-items-center shadow-lg"><MoveHorizontal className="w-5 h-5" /></span>
          </div>
          <span className="absolute top-3 left-3 rounded-full bg-slate-900/80 text-white text-xs font-semibold px-3 py-1" data-testid="finish-compare-standard-label">Standard · {std.name}</span>
          <span className="absolute top-3 right-3 rounded-full bg-ba text-white text-xs font-semibold px-3 py-1" data-testid="finish-compare-upgrade-label">{up.name} · +{money(up.price)}</span>
          <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(+e.target.value)} aria-label="Compare slider" className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize" data-testid="finish-compare-slider" />
        </div>
        {ups.length > 1 && (
          <div className="flex gap-2 flex-wrap" data-testid="finish-compare-upgrade-list">
            {ups.map((o) => <button key={o.id} onClick={() => setUpId(o.id)} className={`h-9 px-4 rounded-full border text-sm ${o.id === up.id ? "bg-slate-900 text-white" : "bg-white"}`} data-testid={`finish-compare-pick-${o.id}`}>{o.name}</button>)}
          </div>
        )}
        <div className="grid grid-cols-2 gap-2">
          <BrandButton variant="ghost" onClick={() => { onPick(cat, std); onClose(); }} data-testid="finish-compare-choose-standard">Keep standard</BrandButton>
          <BrandButton onClick={() => { onPick(cat, up); onClose(); }} data-testid="finish-compare-choose-upgrade">Choose {up.name}</BrandButton>
        </div>
      </DialogContent>
    </Dialog>
  );
}
